/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".barcode-container[_ngcontent-%COMP%]{border:solid #000;border-width:1px;max-height:50px;max-width:50px}"];
export { styles as styles };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/view-request/request-barcode/request-barcode.component.css.shim.ngstyle.js.pre-build-optimizer.js